import { render, staticRenderFns } from "./contentTable-single.vue?vue&type=template&id=af45a554&scoped=true"
import script from "./contentTable-single.vue?vue&type=script&lang=js"
export * from "./contentTable-single.vue?vue&type=script&lang=js"
import style0 from "./contentTable-single.vue?vue&type=style&index=0&id=af45a554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af45a554",
  null
  
)

export default component.exports